import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgPersonCircle = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path
          fill="currentColor"
          d="M12.316 12.342s4.356-5.445.139-8.081c0 0-2.123-1.816-4.57-1.09l.24.61s-3.983 3.335-1.067 7.38c0 0 2.26 2.634-.625 3.908L3 16.635s.012.168 1.045 1.003c0 0 5.89 2.719 9.717 1.158.332-.136 3.17-1.221 3.238-2.533 0 0-6.194-1.103-4.684-3.92z"
        />
        <circle cx={10} cy={10} r={9.5} stroke="currentColor" />
      </g>
    </svg>
  );
};
export default SvgPersonCircle;
